import autocomplete from "../../07-libs/searchAutocomplete";

export default function initializeSearchResultpage() {
  const item = document.querySelector(".searchbox--searchpage");
  if (!item) return;

  const input = item.querySelector("input");
  const autocompleteContainer = item.querySelector(
    ".autocomplete-container"
  );
  if (!input || !autocompleteContainer) return;
  const options = {
    hasResultsCallback: () => {
      autocompleteContainer.classList.add("active");
    },
    noResultsCallback: () => {
      autocompleteContainer.classList.remove("active");
    },
    amount: 4,
  };
  const searchPageUrl = item.dataset.searchPage;
  if (searchPageUrl) {
    options.renderResultAsLink = true;
    options.searchResultLink = item.dataset.searchPage;
  }
  new autocomplete(input, autocompleteContainer, options);
}
